import { render, staticRenderFns } from "./BloggerDetail.vue?vue&type=template&id=68d580a1"
import script from "./BloggerDetail.vue?vue&type=script&lang=js"
export * from "./BloggerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports